export function OutlineHandIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 15V11.9952C7 10.8912 6.1072 9.9984 5.0032 9.9984H4V19.0032C4 20.1072 4.8928 21 5.9968 21H17.0032C18.1072 21 19 20.1072 19 19.0032V7.4976C19 6.6672 18.328 6 17.5024 6C16.672 6 16.0048 6.672 16.0048 7.4976V11.9952V5.5008C16.0048 4.6704 15.3328 4.0032 14.5072 4.0032C13.6768 4.0032 13.0096 4.6752 13.0096 5.5008V12V4.4976C13.0096 3.6672 12.3376 3 11.512 3C10.6816 3 10.0144 3.672 10.0144 4.4976V11.9952V5.5008C10.0144 4.6704 9.3424 4.0032 8.5168 4.0032C7.6864 4.0032 7.0192 4.6752 7.0192 5.5008V15H7Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
